import EditAddressModal from './EditAddressModal';

export default EditAddressModal;


// WEBPACK FOOTER //
// ./src/components/EditAddressModal/index.jsx